export type TrailProgressStation = {
  attended: boolean;
};

/**
 * Returns the last index in the continuous attended segment from the start.
 *
 * Later attended stations are still rendered as completed nodes, but the trail
 * line only represents pages completed in order.
 */
export function lastContinuousAttendedIndex(
  stations: readonly TrailProgressStation[],
): number {
  let lastIndex = -1;
  for (let i = 0; i < stations.length; i++) {
    if (!stations[i].attended) break;
    lastIndex = i;
  }
  return lastIndex;
}
